<p-drawer ngSkipHydration [(visible)]="isVisible" position="bottom" [modal]="false"
          (visibleChange)="onVisibleChange($event)"
          styleClass="w-[95vw] md:w-[80vw] max-w-[1500px] rounded-t-2xl !left-1/2 !-translate-x-1/2 h-auto">
  <ng-template pTemplate="header">
    <div class="w-full flex flex-col gap-0.5">
      <span class="text-xs font-bold tracking-[0.2em] uppercase text-primary-500">
        Bezpłatna konsultacja
      </span>
      <h3 class="m-0 text-xl text-secondary-800 font-semibold">
        Porozmawiajmy — jesteśmy do Twojej dyspozycji
      </h3>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="flex flex-col gap-3">
      <p class="m-0 text-base leading-relaxed text-surface-500">
        Nasi doradcy odpowiedzą na każde pytanie dotyczące oferty autoparku.
        Działamy od poniedziałku do piątku — zawsze gotowi by pomóc.
      </p>
      <div class="flex items-center gap-2">
        <i class="pi pi-clock text-sm text-primary-400"></i>
        <span class="text-sm font-medium text-surface-600">
          Pon.– Pt. 8:00–16:00
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="inline-flex items-center gap-2">
      <a [href]="`tel:${phone()}`" class="no-underline">
        <p-button
          (onClick)="onCall()"
          size="small"
          [label]="phone()"
          icon="pi pi-phone"
          rounded/>
      </a>
      <p-button
        label="Innym razem"
        icon="pi pi-times"
        rounded
        (onClick)="onClose()"
        severity="secondary"
        size="small"
        outlined/>
    </div>
  </ng-template>

</p-drawer>
